import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Divider,
  Box,
  Skeleton,
  Modal,
  Backdrop,
  Fade,
  Button,
  Rating,
  CircularProgress,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import ImageCarousel from "../../common/ImageCarousel";
import StarRating from "./StarRating";
import CustomButton from "../../common/Button/CustomButton";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RecentlyViewedContext from "../../../context/recentlyViewed/RecentlyViewedContext";
import CartItemsContext from "../../../context/cartItems/CartItemsContext";
import AllProductContext from "../../../context/allProducts/AllProductsContext";
import ProductsContainer from "./ProductsContainer";
import LikedItemsContext from "../../../context/likedItems/LikedItemsContext";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Link, useLocation } from "react-router-dom";
import metaPixel from "../../../utils/analytics/metaPixel";
import CustomisedSnackbar from "../../common/Snackbar/CustomisedSnackbar";
import Loader from "../../loader/Loader";
import CustomSeparatorBreadcrumb from "../../common/Breadcrumb/CustomSeparatorBreadcrumb";
import CustomerReviews from "../Reviews/CustomerReviews";
import AddReview from "../Reviews/AddReview";
import AllReviewsContext from "../../../context/allReviews/AllReviewsContext";
import UserProfileContext from "../../../context/userProfile/UserProfileContext";
import { Helmet } from "react-helmet";
import FlipkartLogo from "./../../../assets/images/Flipkart-Logo.png";
import AmazonLogo from "./../../../assets/images/Amazon_logo.png";
import Tata1mgLogo from "./../../../assets/images/TATA1mg_logo.png";

const Root = styled("div")({
  flexGrow: 1,
  padding: "1rem",
  marginTop: "1rem",
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "92%",
  maxWidth: 540,
  maxHeight: "90vh",
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: "0 20px 48px rgba(0, 0, 0, 0.22)",
  p: { xs: 2.5, sm: 3.5 },
  overflowY: "auto",
  outline: "none",
};
const Item = styled("div")(({ theme }) => ({
  // backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  // ...theme.typography.body2,
  margin: "0 0.2rem",
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ProductDetail = ({ product }) => {
  const location = useLocation();
  const productVisit = useMemo(() => ({ key: location.key }), [location.key]);
  useEffect(() => {
    metaPixel.viewContent(product, productVisit);
  }, [product, productVisit]);

  const [open, setOpen] = useState(false);
  const [openReview, setOpenReview] = useState(false);
  const handleReviewOpen = () => setOpenReview(true);
  const handleReviewClose = () => setOpenReview(false);
  const [itemCount, setItemCount] = useState(null);
  const addToCartClicked = useRef(false);
  const buttonText = useRef("Add to cart");
  const cartMessage = useRef("");
  const recentlyViewedContext = useContext(RecentlyViewedContext);
  const cartItemsContext = useContext(CartItemsContext);
  const recentlyViewedItems = recentlyViewedContext.state;
  const allProductContext = useContext(AllProductContext);
  const allProductsArray = allProductContext.state;
  const allReviewsContext = useContext(AllReviewsContext);
  const userProfileContext = useContext(UserProfileContext);
  const user = userProfileContext.state;
  const likedItemsContext = useContext(LikedItemsContext);
  const [likedItemsArray, setLikedItemsArray] = useState([]);
  const [liked, setLiked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [reviewByUser, setReviewByUser] = useState(null);
  const [productURL, setProductURL] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [productImage, setProductImage] = useState("");
  const [proRating, setProRating] = useState({
    avg: 0,
    ratings: [],
    reviews: [],
  });
  //console.log("product:", product);
  let breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" to="/">
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      to={"/collections/" + product.parentCategory.id}
    >
      {product.parentCategory.name}
    </Link>,
  ];
  if (product.categories.length > 0) {
    breadcrumbs.push(
      <Link
        underline="hover"
        key="3"
        color="inherit"
        to={"/collections/" + product.categories[0]}
      >
        <span style={{ textTransform: "capitalize" }}>
          {product.categories[0].replace(/_/g, " ").toLowerCase()}
        </span>
      </Link>
    );
  }
  // breadcrumbs.push(
  //   <Typography
  //     key="4"
  //     color="text.primary"
  //     sx={{textTransform: "capitalize"}}
  //     noWrap
  //     maxWidth="100%"
  //   >
  //     {product.id}
  //   </Typography>
  // );

  useEffect(() => {
    const parentCatId = product.parentCategory?.id || "";
    const urlOfProduct =
      "https://inproveda.com/collections/" +
      parentCatId +
      (parentCatId ? "/" : "") +
      (product.id || "");
    const titleOfProduct = (product.title || "").substr(0, 65);
    const productDesc = (product.description || "").substr(0, 65);
    const productImage =
      product.images?.[0]?.url ||
      (typeof product.images?.[0] === "string" ? product.images[0] : "") ||
      product.imageUrl ||
      product.image ||
      "";
    setProductURL(urlOfProduct);
    setProductTitle(titleOfProduct);
    setProductDescription(productDesc);
    setProductImage(productImage);
    clearRefs();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 150);
    setLiked(false);
    const tempLikedItems = likedItemsContext.state || [];
    setLikedItemsArray(tempLikedItems);
    if (tempLikedItems !== null) {
      const indexOfProductInLikedItems = tempLikedItems.findIndex(
        (a) => a.id === product.id
      );
      if (indexOfProductInLikedItems !== -1) {
        setLiked(true);
      }
    }

    // Get CartState
    const tempCartItems = cartItemsContext.state;
    // console.log("tempCartItems:", tempCartItems);
    // Check if this product already added to cart
    if (tempCartItems !== null && tempCartItems.length > 0) {
      const indexOfProductInCart = tempCartItems.findIndex(
        (a) => a.id === product.id
      );
      // console.log("indexOfProductInCart:", indexOfProductInCart);
      // Update product if already in array
      if (indexOfProductInCart !== -1) {
        addToCartClicked.current = true;
        let tempItemCount = tempCartItems[indexOfProductInCart].quantity;
        setItemCount(tempItemCount);
        if (tempItemCount === 1) {
          buttonText.current = "1 Unit in cart";
        } else {
          buttonText.current = tempItemCount + " units in cart";
          // console.log("buttonText.current:", buttonText.current);
        }
      }
    }
    // Check if product already in RecentlyViewedItems Array
    const indexOfProductInRecentlyViewed = recentlyViewedItems.findIndex(
      (a) => a.id === product.id
    );
    // Remove product if already in array
    if (indexOfProductInRecentlyViewed !== -1) {
      recentlyViewedItems.splice(indexOfProductInRecentlyViewed, 1);
    }
    // Add product at top of the array
    recentlyViewedContext.setState([product, ...recentlyViewedItems]);
    // Check max length of RecentlyViewedItems Array
    if (recentlyViewedItems.length === 10) {
      recentlyViewedItems.pop();
    }
    if (product.ratings && product.ratings.length > 0) {
      const prod_rating_average =
        product.ratings.reduce((a, b) => a + b, 0) / product.ratings.length;
      const rating_average = Math.round(prod_rating_average / 0.5) * 0.5;
      const setData = {
        avg: rating_average,
        ratings: product.ratings,
        reviews: product.reviews ? product.reviews : [],
      };
      //console.log("1. UPDATE PRO RATING====>", setData);
      setProRating({
        ...setData,
      });
    }
    // Check if user has already added review for this produuct
    if (
      user !== undefined &&
      user !== null &&
      user.reviews !== undefined &&
      product.reviews !== undefined
    ) {
      const userReviewsIds = user.reviews || [];
      const productReviewsIds = product.reviews || [];
      const commonId = userReviewsIds.filter((item) =>
        productReviewsIds.includes(item)
      );
      //console.log("1. commonId:", commonId);
      if (commonId.length > 0) {
        const reviewData = allReviewsContext.state.filter((item) => {
          return item.id === commonId[0];
        });
        //console.log("1. SET REVIEW BY USER ====>", reviewData[0]);
        setReviewByUser({ ...reviewData[0] });
      }
    }
  }, [product.id]);

  useEffect(() => {
    // console.log(
    //   "2. ALL PRODUCTS ARRAY OR USER CHANGED =======>",
    //   allProductsArray,
    //   " user:",
    //   user
    // );
    const prod = allProductsArray.filter((item) => item.id === product.id);
    //console.log("2. prod now:", prod[0]);
    if (prod[0].ratings && prod[0].ratings.length > 0) {
      const p_rating_average =
        prod[0].ratings.reduce((a, b) => a + b, 0) / prod[0].ratings.length;
      const rating_average = Math.round(p_rating_average / 0.5) * 0.5;
      const setData = {
        avg: rating_average,
        ratings: prod[0].ratings,
        reviews: prod[0].reviews ? prod[0].reviews : [],
      };
      //console.log("2. UPDATE PRO RATING====>", setData);
      setProRating({
        ...setData,
      });
    }
    if (
      user !== undefined &&
      user !== null &&
      user.reviews !== undefined &&
      product.reviews !== undefined
    ) {
      const userReviewsIds = user.reviews || [];
      const productReviewsIds = product.reviews || [];
      const commonId = userReviewsIds.filter((item) =>
        productReviewsIds.includes(item)
      );
      //console.log("2. commonId:", commonId);
      if (commonId.length > 0) {
        const reviewData = allReviewsContext.state.filter((item) => {
          return item.id === commonId[0];
        });
        //console.log("2. SET REVIEW BY USER ====>", reviewData[0]);
        setReviewByUser({ ...reviewData[0] });
      }
    }
  }, [allProductsArray, user]);

  useEffect(() => {
    // console.log(
    //   "3. ALL REVIEWS CONTEXT OR ALL PRODUCTS ARRAY OR USER CHANGED =====> ",
    //   allReviewsContext.state,
    //   " user:",
    //   user,
    //   " allProductsArray:",
    //   allProductsArray
    // );
    const prod = allProductsArray.filter((item) => item.id === product.id);
    //console.log("3. prod now:", prod[0]);
    // Check if user has already added review for this produuct
    if (
      user !== undefined &&
      user !== null &&
      user.reviews !== undefined &&
      prod[0].reviews !== undefined
    ) {
      const userReviewsIds = user.reviews || [];
      const productReviewsIds = prod[0].reviews || [];
      // console.log(
      //   "3. userReviewsIds:",
      //   userReviewsIds,
      //   " productReviewsIds:",
      //   productReviewsIds
      // );

      const commonId = userReviewsIds.filter((item) =>
        productReviewsIds.includes(item)
      );
      //console.log("3. commonId:", commonId);
      if (commonId.length > 0) {
        const reviewData = allReviewsContext.state.filter((item) => {
          return item.id === commonId[0];
        });
        //console.log("3. SET REVIEW BY USER====>", reviewData[0]);
        setReviewByUser({ ...reviewData[0] });
      }
    }
  }, [allReviewsContext.state, user, allProductsArray]);

  useEffect(() => {
    //console.log("PRO RATING CHANGED =======> ", proRating);
  }, [proRating]);
  useEffect(() => {
    //console.log("REVIEW BY USER CHANGED =======> ", reviewByUser);
  }, [reviewByUser]);
  useEffect(() => {
    // console.log("itemCount changed:", itemCount);
    if (itemCount !== null) {
      handleCartUpdate();
    }
  }, [itemCount]);
  useEffect(() => {
    if (updating) {
      setUpdating(false);
    }
  }, [cartItemsContext.state]);

  const handleLikeItem = () => {
    const likedItemsArray = likedItemsContext.state;
    if (likedItemsArray !== null) {
      const indexOfProductInLikedItems = likedItemsArray.findIndex(
        (a) => a.id === product.id
      );
      if (indexOfProductInLikedItems !== -1) {
        cartMessage.current = product.title + " removed from wishlist";
        likedItemsArray.splice(indexOfProductInLikedItems, 1);
        likedItemsContext.setState([...likedItemsArray]);
        setLiked(false);
      } else {
        // likedItemsArray.push(product);
        cartMessage.current = product.title + " added to wishlist";
        likedItemsContext.setState([product, ...likedItemsArray]);
        setLiked(true);
      }
    } else {
      cartMessage.current = product.title + " added to wishlist";
      likedItemsContext.setState([product]);
      setLiked(true);
    }
    setOpen(true);
  };
  const clearRefs = () => {
    // console.log("Clear Refs");
    setReviewByUser(null);
    const setData = {
      avg: 0,
      ratings: [],
      reviews: [],
    };
    setProRating({ ...setData });
    setItemCount(null);
    addToCartClicked.current = false;
    buttonText.current = "Add to cart";
    cartMessage.current = "";
    setOpen(false);
    setUpdating(false);
  };
  const handleAddToCart = () => {
    setUpdating(true);
    setTimeout(() => {
      // As this product has been added to cart, Remove it from RecentlyViewedItems Array
      const indexOfProduct = recentlyViewedItems.findIndex(
        (a) => a.id === product.id
      );
      // Remove product if already in array
      if (indexOfProduct !== -1) {
        recentlyViewedItems.splice(indexOfProduct, 1);
      }
      addToCartClicked.current = !addToCartClicked.current;
      setItemCount(1);
      cartMessage.current = "1 unit of " + product.title + " added to cart";
      buttonText.current = "1 Unit in cart";
      setOpen(true);
    }, 200);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleMinusIconClick = () => {
    setUpdating(true);
    setTimeout(() => {
      if (itemCount === 1) {
        cartMessage.current = product.title + " removed from cart";
        recentlyViewedContext.setState([product, ...recentlyViewedItems]);
        addToCartClicked.current = false;
        buttonText.current = "Add to cart";
        setItemCount(0);
        setOpen(true);
      } else {
        let tempItemCount = itemCount - 1;
        setItemCount((prevState) => prevState - 1);
        buttonText.current = tempItemCount + " units in cart";
        cartMessage.current =
          "1 unit of " + product.title + " removed from cart";
        setOpen(true);
      }
    }, 200);
  };
  const handlePlusIconClick = () => {
    setUpdating(true);
    setTimeout(() => {
      let tempItemCount = itemCount + 1;
      setItemCount((prevState) => prevState + 1);
      buttonText.current = tempItemCount + " units in cart";
      cartMessage.current =
        "1 more unit of " + product.title + " added to cart";
      setOpen(true);
    }, 200);
  };
  const handleCartUpdate = () => {
    const previousQuantity = Number((cartItemsContext.state || []).find((item) => item.id === product.id)?.quantity || 0);
    // Check if product already in Cart State
    if (cartItemsContext.state !== null) {
      const indexOfProduct = cartItemsContext.state.findIndex(
        (a) => a.id === product.id
      );
      // Update product if already in array
      if (indexOfProduct !== -1) {
        if (itemCount !== 0) {
          const updatedCartItem = {
            ...cartItemsContext.state[indexOfProduct],
            quantity: itemCount,
          };
          const tempCartItems = cartItemsContext.state;
          tempCartItems.splice(indexOfProduct, 1);

          cartItemsContext.setState((prevState) => [
            updatedCartItem,
            ...tempCartItems,
          ]);
        } else {
          const tempCartItems = cartItemsContext.state;
          // Remove item from cart state
          tempCartItems.splice(indexOfProduct, 1);
          cartItemsContext.setState([...tempCartItems]);
        }
      } else {
        // Add product to the cart state if quantity is greater than 0
        if (itemCount !== 0) {
          cartItemsContext.setState((prevState) => [
            { ...product, quantity: itemCount },
            ...prevState,
          ]);
        }
      }
    } else {
      // Add product to the cart state if quantity is greater than 0
      if (itemCount !== 0) {
        cartItemsContext.setState([{ ...product, quantity: itemCount }]);
      }
    }
    if (itemCount > previousQuantity) {
      metaPixel.addToCart(product, itemCount - previousQuantity);
    }
  };
  const onCloseReview = () => {
    setOpenReview(false);
  };

  return !loading ? (
    <Root>
      <Helmet>
        <title>{productTitle}</title>
        <meta property="og:url" content={productURL} />
        <meta property="og:type" content="product" />
        <meta property="og:title" content={productTitle} />
        <meta property="og:description" content={productDescription} />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/inproveda-eae6e.appspot.com/o/images%2Fproducts%2Frosemary-oil.jpg?alt=media&token=a6a17f59-b983-461a-97f1-9588f310e4aa"
        />
        <meta name="keywords" content={product.searchTerms}></meta>‍
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} sx={{ position: "relative" }}>
          {(() => {
            const rawImages = Array.isArray(product.images) && product.images.length > 0
              ? product.images
              : (product.imageUrl || product.image)
              ? [{ url: product.imageUrl || product.image }]
              : [];

            const mediaArr = rawImages
              .map((a) => {
                const url = typeof a === "string" ? a : a?.url || a?.original || "";
                return url ? { type: "image", url } : null;
              })
              .filter(Boolean);

            if (product.video && product.video.url) {
              mediaArr.push({
                type: "video",
                url: product.video.url,
                poster: mediaArr[0]?.url || undefined,
              });
            }

            if (mediaArr.length === 0) {
              return (
                <Box
                  data-testid="product-image-skeleton-gallery"
                  sx={{
                    width: "100%",
                    minHeight: { xs: 350, sm: 500 },
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                    color: "text.secondary",
                  }}
                >
                  <Typography variant="body2">No product image available</Typography>
                </Box>
              );
            }

            return (
              <ImageCarousel
                className="product-detail-carousel"
                showThumbs={true}
                ImagesArr={mediaArr}
                zoomOnHover={true}
              />
            );
          })()}
          <IconButton
            className="icon-float favorite-icon wow fadeIn"
            data-wow-delay="0.25s"
            onClick={() => handleLikeItem()}
            sx={{ top: "40px !important", right: "30px !important" }}
          >
            <FavoriteIcon
              sx={{ width: "1.1em", height: "1.1em" }}
              className={liked ? "favorite-icon-true" : "favorite-icon-false"}
            />
          </IconButton>
        </Grid>
        <Grid item xs={12} md={6} sx={{ paddingTop: "0 !important" }}>
          <Grid
            sx={{ display: { xs: "none", sm: "block" }, marginBottom: "1rem" }}
            item
            xs={12}
            textAlign="right"
          >
            <CustomSeparatorBreadcrumb breadcrumbs={breadcrumbs} />
          </Grid>
          <Card>
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="h5"
                className="wow fadeIn"
              >
                {product.title}
              </Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "opacity 0.2s ease",
                  "&:hover": { opacity: 0.8 },
                }}
                onClick={() => {
                  const el = document.getElementById("customer-reviews-section");
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                  }
                }}
                title="View customer ratings and reviews"
              >
                <StarRating
                  rating={proRating.avg}
                  showTotalNumber={proRating.ratings.length}
                  showLabel={true}
                />
              </Box>
              <Typography className="discount-percent-detail" variant="">
                -
                {Math.ceil(
                  ((product.maxPrice - product.listPrice) / product.maxPrice) *
                    100
                )}
                %
              </Typography>
              <Typography
                variant="body"
                color="primary"
                className="list-price-detail"
              >
                &#8377;{product.listPrice}
              </Typography>
              <Typography variant="" className="mrp-text">
                M.R.P.
              </Typography>

              <Typography className="max-price" variant="">
                &#8377;{product.maxPrice}
              </Typography>
              <Grid container spacing={2} alignItems="center" sx={{ marginTop: "1rem" }}>
                {addToCartClicked.current && itemCount > 0 ? (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      md={5}
                      className="wow fadeInUp"
                      data-wow-delay="0.15s"
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          height: 48,
                          px: 1.5,
                          borderRadius: "12px",
                          backgroundColor: "#f0fdf4",
                          border: "1.5px solid #075e54",
                          boxShadow: "0 2px 8px rgba(7, 94, 84, 0.12)",
                        }}
                      >
                        <Tooltip
                          title={itemCount === 1 ? "Remove from cart" : "Remove 1 unit"}
                          placement="top"
                        >
                          <span>
                            <IconButton
                              aria-label="remove unit"
                              disabled={updating}
                              onClick={handleMinusIconClick}
                              sx={{
                                color: itemCount === 1 ? "#ef4444" : "#075e54",
                                width: 34,
                                height: 34,
                                p: 0,
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  backgroundColor:
                                    itemCount === 1
                                      ? "rgba(239, 68, 68, 0.12)"
                                      : "rgba(7, 94, 84, 0.1)",
                                  transform: "scale(1.1)",
                                },
                                "&:active": {
                                  transform: "scale(0.92)",
                                },
                              }}
                            >
                              <RemoveIcon sx={{ fontSize: "1.25rem" }} />
                            </IconButton>
                          </span>
                        </Tooltip>

                        <Box sx={{ textAlign: "center", userSelect: "none" }}>
                          <Typography
                            sx={{
                              fontWeight: 800,
                              fontSize: "1.1rem",
                              color: "#075e54",
                              lineHeight: 1.1,
                            }}
                          >
                            {itemCount}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              color: "#0a6157",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                            }}
                          >
                            in cart
                          </Typography>
                        </Box>

                        <Tooltip title="Add 1 unit" placement="top">
                          <span>
                            <IconButton
                              aria-label="add unit"
                              disabled={
                                updating ||
                                (typeof product.unitsInStock === "number" &&
                                  itemCount >= product.unitsInStock)
                              }
                              onClick={handlePlusIconClick}
                              sx={{
                                color:
                                  typeof product.unitsInStock === "number" &&
                                  itemCount >= product.unitsInStock
                                    ? "#94a3b8"
                                    : "#075e54",
                                width: 34,
                                height: 34,
                                p: 0,
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  backgroundColor: "rgba(7, 94, 84, 0.1)",
                                  transform: "scale(1.1)",
                                },
                                "&:active": {
                                  transform: "scale(0.92)",
                                },
                              }}
                            >
                              <AddIcon sx={{ fontSize: "1.25rem" }} />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={7}
                      md={7}
                      className="wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <Link to="/cart" style={{ textDecoration: "none", width: "100%", display: "block" }}>
                        <CustomButton
                          fullWidth={true}
                          variant="contained"
                          size="large"
                          startIcon={<FlashOnIcon sx={{ fontSize: "1.25rem" }} />}
                          sx={{
                            height: 48,
                            borderRadius: "12px",
                            textTransform: "none",
                            fontWeight: 700,
                            letterSpacing: "0.4px",
                            fontSize: "1rem",
                            background: "linear-gradient(135deg, #075e54 0%, #0d7064 100%)",
                            backgroundColor: "#075e54",
                            color: "#ffffff",
                            boxShadow: "0 4px 14px rgba(7, 94, 84, 0.28)",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                              background: "linear-gradient(135deg, #05463f 0%, #0a5d53 100%)",
                              backgroundColor: "#05463f",
                              boxShadow: "0 6px 20px rgba(7, 94, 84, 0.38)",
                              transform: "translateY(-1px)",
                            },
                            "&:active": {
                              transform: "scale(0.99)",
                            },
                          }}
                        >
                          Go to cart
                        </CustomButton>
                      </Link>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      className="wow fadeInUp"
                      data-wow-delay="0.15s"
                    >
                      <CustomButton
                        fullWidth={true}
                        variant="contained"
                        size="large"
                        disabled={
                          updating ||
                          (typeof product.unitsInStock === "number" &&
                            product.unitsInStock <= 0)
                        }
                        onClick={() => {
                          if (!addToCartClicked.current) {
                            handleAddToCart();
                          }
                        }}
                        startIcon={
                          updating ? (
                            <CircularProgress
                              size={18}
                              sx={{ color: "rgba(255, 255, 255, 0.85)" }}
                            />
                          ) : (
                            <AddShoppingCartIcon sx={{ fontSize: "1.25rem" }} />
                          )
                        }
                        sx={{
                          height: 48,
                          borderRadius: "12px",
                          textTransform: "none",
                          fontWeight: 700,
                          letterSpacing: "0.4px",
                          fontSize: "1rem",
                          background:
                            typeof product.unitsInStock === "number" &&
                            product.unitsInStock <= 0
                              ? "rgba(0, 0, 0, 0.08)"
                              : "linear-gradient(135deg, #075e54 0%, #0d7064 100%)",
                          backgroundColor:
                            typeof product.unitsInStock === "number" &&
                            product.unitsInStock <= 0
                              ? "rgba(0, 0, 0, 0.08)"
                              : "#075e54",
                          color:
                            typeof product.unitsInStock === "number" &&
                            product.unitsInStock <= 0
                              ? "rgba(0, 0, 0, 0.38)"
                              : "#ffffff",
                          boxShadow:
                            typeof product.unitsInStock === "number" &&
                            product.unitsInStock <= 0
                              ? "none"
                              : "0 4px 14px rgba(7, 94, 84, 0.28)",
                          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            background:
                              typeof product.unitsInStock === "number" &&
                              product.unitsInStock <= 0
                                ? "rgba(0, 0, 0, 0.08)"
                                : "linear-gradient(135deg, #05463f 0%, #0a5d53 100%)",
                            backgroundColor:
                              typeof product.unitsInStock === "number" &&
                              product.unitsInStock <= 0
                                ? "rgba(0, 0, 0, 0.08)"
                                : "#05463f",
                            boxShadow:
                              typeof product.unitsInStock === "number" &&
                              product.unitsInStock <= 0
                                ? "none"
                                : "0 6px 20px rgba(7, 94, 84, 0.38)",
                            transform:
                              typeof product.unitsInStock === "number" &&
                              product.unitsInStock <= 0
                                ? "none"
                                : "translateY(-1px)",
                          },
                          "&:active": {
                            transform: "scale(0.99)",
                          },
                          "&:disabled": {
                            backgroundColor: "#f1f5f9",
                            color: "#94a3b8",
                            boxShadow: "none",
                            cursor: "not-allowed",
                          },
                        }}
                      >
                        {typeof product.unitsInStock === "number" &&
                        product.unitsInStock <= 0
                          ? "Out of Stock"
                          : updating
                          ? "Adding..."
                          : "Add to cart"}
                      </CustomButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      className="wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <Link to="/cart" style={{ textDecoration: "none", width: "100%", display: "block" }}>
                        <CustomButton
                          fullWidth={true}
                          variant="outlined"
                          size="large"
                          startIcon={<FlashOnIcon sx={{ fontSize: "1.25rem" }} />}
                          sx={{
                            height: 48,
                            borderRadius: "12px",
                            textTransform: "none",
                            fontWeight: 700,
                            letterSpacing: "0.4px",
                            fontSize: "1rem",
                            border: "1.5px solid #075e54",
                            borderColor: "#075e54",
                            color: "#075e54",
                            backgroundColor: "rgba(7, 94, 84, 0.03)",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                              backgroundColor: "rgba(7, 94, 84, 0.08)",
                              borderColor: "#05463f",
                              color: "#05463f",
                              transform: "translateY(-1px)",
                              boxShadow: "0 4px 12px rgba(7, 94, 84, 0.12)",
                            },
                            "&:active": {
                              transform: "scale(0.99)",
                            },
                          }}
                        >
                          Go to cart
                        </CustomButton>
                      </Link>
                    </Grid>
                  </>
                )}
                {((product.flipkartURL !== undefined &&
                  product.flipkartURL !== "") ||
                  (product.amazonURL !== undefined &&
                    product.amazonURL !== "") ||
                  (product.tata1mgURL !== undefined &&
                    product.tata1mgURL !== "")) && (
                  <Grid
                    item
                    xs={12}
                    className="wow fadeInUp"
                    data-wow-delay="0.25s"
                    style={{ marginTop: "1rem" }}
                  >
                    <Typography variant="p">Also available on</Typography>
                  </Grid>
                )}
                <Grid item container justifyContent="space-evenly">
                  {product.flipkartURL !== undefined &&
                    product.flipkartURL !== "" && (
                      <Grid
                        item
                        className="wow fadeInUp"
                        data-wow-delay="0.30s"
                      >
                        <a
                          href={product.flipkartURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          <img
                            src={FlipkartLogo}
                            className="flipkart-icon"
                          ></img>
                        </a>
                      </Grid>
                    )}
                  {product.amazonURL !== undefined &&
                    product.amazonURL !== "" && (
                      <Grid
                        item
                        className="wow fadeInUp"
                        data-wow-delay="0.35s"
                      >
                        <a
                          href={product.amazonURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          <img src={AmazonLogo} className="amazon-icon"></img>
                        </a>
                      </Grid>
                    )}
                  {product.tata1mgURL !== undefined &&
                    product.tata1mgURL !== "" && (
                      <Grid
                        item
                        className="wow fadeInUp"
                        data-wow-delay="0.30s"
                      >
                        <a
                          href={product.tata1mgURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "block",
                            textAlign: "center",
                          }}
                        >
                          <img src={Tata1mgLogo} className="tata1mg-icon"></img>
                        </a>
                      </Grid>
                    )}
                </Grid>
              </Grid>
              <Typography
                variant="body1"
                color="textSecondary"
                component="p"
                sx={{ margin: "1rem 0", color: "black" }}
                className="wow fadeInUp"
                data-wow-delay="0.5s"
              >
                <span
                  dangerouslySetInnerHTML={{ __html: product.description }}
                ></span>
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "1rem" }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <CustomerReviews
            productReviewsData={{ ...proRating }}
            allReviews={allReviewsContext.state}
            reviewByUser={reviewByUser}
            onWriteReview={handleReviewOpen}
            product={product}
          />
        </Grid>
      </Grid>
      {product.categories.map((categoryId) => {
        const tempProducts = allProductsArray.filter((item) => {
          return item.categories.includes(categoryId) && item.id !== product.id;
        });
        return (
          tempProducts.length > 0 && (
            <Grid
              container
              spacing={2}
              key={categoryId}
              sx={{ marginTop: "1rem" }}
            >
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <ProductsContainer
                  heading={`More ${categoryId.replace(/_/g, " ")}`}
                  showInRow={true}
                  addToCartEnable={true}
                  showCarousel={false}
                  productsArray={tempProducts}
                  showRatingNumber={false}
                />
              </Grid>
            </Grid>
          )
        );
      })}

      {/* likedItemsArray */}
      {likedItemsArray.length > 0 && (
        <Grid container spacing={2} sx={{ marginTop: "1rem" }}>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <ProductsContainer
              heading={`Products you have Liked`}
              showInRow={true}
              addToCartEnable={true}
              showCarousel={false}
              productsArray={likedItemsArray}
              fadeOutOnRemovingLike={true}
              showRatingNumber={false}
            />
          </Grid>
        </Grid>
      )}
      <CustomisedSnackbar
        message={cartMessage.current}
        severity="success"
        open={open}
        handleClose={handleClose}
      />
      {updating && <Loader />}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openReview}
        onClose={handleReviewClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openReview}>
          <Box sx={style}>
            <AddReview
              product={product}
              reviewData={reviewByUser}
              handleClose={onCloseReview}
            />
          </Box>
        </Fade>
      </Modal>
    </Root>
  ) : (
    <Root>
      <Helmet>
        <title>{productTitle}</title>
        <meta property="og:url" content={productURL} />
        <meta property="og:type" content="product" />
        <meta property="og:title" content={productTitle} />
        <meta property="og:description" content={productDescription} />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/inproveda-eae6e.appspot.com/o/images%2Fproducts%2Frosemary-oil.jpg?alt=media&token=a6a17f59-b983-461a-97f1-9588f310e4aa"
        />
        <meta name="keywords" content={product.searchTerms}></meta>‍
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          {/* Main Image Skeleton */}
          <Skeleton
            data-testid="product-detail-image-skeleton"
            variant="rectangular"
            animation="wave"
            sx={{
              width: "100%",
              height: { xs: 350, sm: 500 },
              borderRadius: "16px",
              backgroundColor: "rgba(0, 0, 0, 0.05)",
            }}
          />
          {/* Thumbnail Skeletons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1.5,
              mt: 2,
            }}
          >
            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                variant="rounded"
                animation="wave"
                width={56}
                height={56}
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                }}
              />
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ p: { xs: 1, sm: 2 } }}>
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="90%" height={44} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="60%" height={32} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="35%" height={28} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="45%" height={40} sx={{ mb: 3 }} />
            <Skeleton
              variant="rounded"
              height={48}
              width="100%"
              sx={{ borderRadius: "12px", mb: 2 }}
            />
            <Skeleton variant="text" width="100%" height={20} sx={{ mt: 2 }} />
            <Skeleton variant="text" width="95%" height={20} />
            <Skeleton variant="text" width="80%" height={20} />
          </Box>
        </Grid>
      </Grid>
    </Root>
  );
};

export default ProductDetail;
